/* eslint-disable */
import isElement from '@dcode/is/element/element';
import computedStyle from './computedStyle';

export const float = (value) => (
	parseFloat(value) || 0
);

export const getElementDimension = (which, element, outer, includeMargin) => {
	const $el = (element === document ? window : element);
	if ($el === window) {
		includeMargin = false;
	} else if (!isElement($el)) {
		return 0;
	}
	which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
	let dimension = (outer
		? $el[`offset${which}`] || $el[`outer${which}`]
		: $el[`client${which}`] || $el[`inner${which}`]
	) || 0;
	if (outer && includeMargin) {
		const style = computedStyle($el);
		dimension += (
			which === 'Height'
			? float(style.marginTop) + float(style.marginBottom)
			: float(style.marginLeft) + float(style.marginRight)
		);
	}
	return dimension;
};

export default getElementDimension;
